<template>
    <div class="form-field form-html" :rel="name" v-bind:class="{'form-required': requiredForm}">
        <div class="form-label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">
              <editor
                  tinymce-script-src="/src/assets/tinymce/tinymce.min.js"
                  v-model="internalValue"
                  :init="configEditor"></editor>
              <!--
                <editor
                    tinymce-script-src="/src/assets/tinymce/tinymce.min.js"
                    v-model="internalValue"
                    xapi-key="mq337f0iug6w4uk6jeq6luf2onnck9isgstl6es1461p7e8q"
                    xapi-key="8de12z8u7irytsdoc9uyvnq5ps1br89eq4keb1nig145bue9"
                    :init="configEditor"></editor>
                    -->
                <!--<froala :tag="'textarea'" :config="config" v-model="internalValue"></froala>-->
              <div class="translate-html"  v-if="translations && Object.keys(translations).length > 1">
                <translator @updateValue="updateValue" :translate-key="translateKey" :lang="lang" :translations="translations" />
                <i :class="langClass" v-if="lang"><img :src="'/src/assets/flags/'+lang+'.svg'"></i>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Editor from '@tinymce/tinymce-vue';
    import Translator from "./Translator.vue";
    export default {
        name: 'FormFieldHtml',
        props: ['value','label','name','placeholder','lang','tag','config','required', 'translateKey', 'translations'],
        components: {
            'editor': Editor,
            'translator' : Translator
        },
        data: function () {
            return {
                internalValue: '',
                langClass: '',
                configEditor: {
                    plugins: "code,table",
                    branding: false,
                    menubar:false,
                    statusbar: false,
                    toolbar: 'bold italic underline | alignleft aligncenter alignright alignjustify | styleselect | fontsizeselect forecolor backcolor | link image media table | numlist bullist | code',
                    useClasses: false,
                    htmlAllowedTags: ['.*'],
                    htmlRemoveTags: [''],
                    fullPage: true,
                    lineBreakerTags: ['']
                }
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.langClass = this.lang?"flag lang-"+this.lang:"";
            this.requiredForm = this.required && this.required == 'true' ? true : false
            //this.configEditor = this.configEditor;
            //this.configEditor = this.config ? this.config : this.configEditor;
        },
        methods: {
          updateValue: function (val) {
            this.internalValue = val
          }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>
<style scoped>
.translate-html {
  display: flex;
  flex-direction: row;
  position: absolute;
  gap: 5px;
  padding: 0.4em 0.5em;
  top: -40px;
  right: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/form/Html.vue